import type { PDFDocument, PDFImage } from 'pdf-lib';
import markDataUrl from '@/assets/zschimmer-mark.png?inline';

// O logo dos PDFs vai embutido no próprio código (data URL), e não buscado do servidor:
// hospedagens com otimização de imagem (como a do Hostinger) entregam o PNG convertido
// para WebP ao navegador, e o gerador de PDF só aceita PNG. Se mesmo assim falhar, o PDF
// sai sem o logo em vez de impedir a geração do documento e o envio do e-mail.
export async function embedBrandLogo(pdf: PDFDocument): Promise<PDFImage | null> {
  try {
    const binary = atob(markDataUrl.slice(markDataUrl.indexOf(',') + 1));
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return await pdf.embedPng(bytes);
  } catch (error) {
    console.error('Logo não incluído no PDF:', error);
    return null;
  }
}
